import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

import { COUNTRY_NAME } from '../../constants/countries'
import type { GameArticle } from '../../types/game'
import { api } from '../../utils/api-client'

interface CategoryContentProps {
  category: string
}

const CategoryContent = ({ category }: CategoryContentProps) => {
  const [article, setArticle] = useState<GameArticle | null>({
    meta_title:
      'Mejores Juegos de Deportes y Casino en Línea | Apuesta con Fun88',
    meta_description: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    content: '',
    meta_keywords: '',
  })

  useEffect(() => {
    const getArticle = async () => {
      try {
        const res = await api.get<GameArticle>('/articles.php', {
          slug: category,
          category: 'casino',
        })
        setArticle(res.data)
      } catch (error) {
        console.error(error)
      }
    }
    getArticle()
  }, [category])

  if (!article) return null
  return (
    <>
      <Helmet>
        <title>{article.meta_title}</title>
        {article.meta_description && (
          <meta name="description" content={article.meta_description} />
        )}
        {article.meta_keywords && (
          <meta name="keywords" content={article.meta_keywords} />
        )}
      </Helmet>
      <div
        className="category-content text-txt w-full px-6 py-0 rounded-xl xl:max-w-[1330px] xl:mx-auto xl:my-9 styled-link"
        dangerouslySetInnerHTML={{ __html: article.content }}
      />
    </>
  )
}

export default CategoryContent
